module.exports = __webpack_public_path__ + "img/4.af245bc4.jpg";